// export const a = 'Discovery.Web-App.Home.Page.client-call';
export const DSCV_HEADER_LOGO_CLICK = 'Discovery.Web-App.Header.Logo.click';
export const DSCV_MAIN_MENU_NAVIGATE_CLICK =
  'Discovery.Web-App.Main-Menu.Navigate.click';
export const DSCV_PRODUCT_BTN_CLICK =
  'Discovery.Web-App.Main-Content.Product-BTN.click';
export const DSCV_GENIE_SPOTLIGHT_CTA_CLICK =
  'Discovery.Web-App.Main-Content.Spotlight-CTA.click';
export const DSCV_BLOG_ARTICLE_CLICK =
  'Discovery.Web-App.Main-Content.Blog-Article.click';
export const DSCV_HERO_CAROUSEL_CTA = 'Discovery.Web-App.Banner.CTA.click';
export const DSCV_JOIN_NEWSLETTER_CLICK =
  'Discovery.Web-App.Footer.Newsletter-BTN-Join.click';
export const DSCV_FOOTER_NAVIGATE_CLICK =
  'Discovery.Web-App.Footer.Navigate.click';
export const DSCV_COOKIE_CONSENT_CLICK =
  'Discovery.Web-App.Overlay.Cookie-Consent-BTN.click';
export const DSCV_FOOTER_SOCIAL_MEDIA_CLICK =
  'Discovery.Web-App.Footer.Social-Media-BTN.click';

// Contact Links
export const STR_ABOUT_US = 'About us';
export const STR_CONTACT_US = 'Contact us';

// Site Links
export const STR_FAQ = 'FAQ';
export const STR_SHOP = 'Shop';
export const STR_COLOR_GENIE = 'ColorGenie';
export const STR_GENIE = 'Genie';
export const STR_BLOG = 'Blog';

// Social Links
export const STR_DISCORD = 'Discord';
export const STR_INSTAGRAM = 'Instagram';
export const STR_YOUTUBE = 'YouTube';
